// extracted by mini-css-extract-plugin
export var fullHeightState = "_50-7";
export var headerCell = "_50-1";
export var loadingStateCell = "_50-4";
export var rowWrapper = "_50-3";
export var standaloneTable = "_50-8";
export var standaloneTableWithBodyFill = "_50-9";
export var stateCell = "_50-5";
export var table = "_50-0";
export var tableBodyFiller = "_50-6";
export var white = "_50-2";